import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Radio = forwardRef(({ name, id, label, value, onFocus, onChange, onKeyDown, tabIndex, checked }, ref) => (
    <div className="govuk-radios__item" data-testid={'radio'}>
        <input
            className="govuk-radios__input"
            id={id}
            name={name}
            type="radio"
            onFocus={onFocus}
            value={value}
            onChange={onChange}
            checked={checked}
            aria-checked={checked}
            aria-label={label}
            data-testid={'radio.input-' + value}
            onKeyDown={onKeyDown}
            tabIndex={tabIndex}
            ref={ref}
        />
        <label className="govuk-label govuk-radios__label" htmlFor={id} data-testid={'radio.label-' + value}>
            {label}
        </label>
    </div>
));

Radio.displayName = 'Radio';

Radio.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    tabIndex: PropTypes.number,
    id: PropTypes.string
};

Radio.defaultProps = {
    onFocus: () => {},
    onChange: () => {}
};

export default Radio;
